module.exports = __webpack_public_path__ + "static/media/car-transfer.448dab14.webp";